































































































































































import {
  LiveManagementCreateLivecarpItemRequest,
  LiveManagementLiveService,
} from "@/common/api";
import QErrors from "@/common/qErrors.vue";
import { isEmpty } from "lodash";
import moment from "moment";
import { PropType } from "vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const live = namespace("Live");

@Component({
  name: "LiveItemPdfComponent",
  components: { QErrors },
})
export default class LiveItemPdfComponent extends Vue {

  get disabled() {
    return !this.$router.currentRoute.params.id;
  }
  public name: "LiveItemPdfComponent";

  @live.Action
  public updateLiveItems!: (items) => void;

  @live.Action
  public updateConfig!: (config) => void;

  @live.Action
  public updateImage!: (image) => void;

  @Prop({
    type: String,
    default: null,
  })
  public image;

  @Prop({
    type: Array as PropType<LiveManagementCreateLivecarpItemRequest[]>,
    default: () => [
      {
        id: null,
        livecarpId: null,
        code: "",
        isNarita: false,
        producer: "",
        producerEn: null,
        producerCn: null,
        kind: "",
        kindEn: null,
        kindCn: null,
        ageId: null,
        sex: LiveManagementCreateLivecarpItemRequest.sex.FEMALE,
        size: null,
        endTime: null,
        parent: null,
        parentEn: null,
        parentCn: null,
        startPrice: null,
        note: null,
        noteEn: null,
        noteCn: null,
        status: LiveManagementCreateLivecarpItemRequest.status.CANCEL,
      },
    ],
  })
  public items;

  @Prop({
    type: Boolean,
    default: false,
  })
  public isEdit;

  public isShow = false;
  public zipFile;

  public config = {
    is_display_code: true,
    date: {
      year: String(new Date().getFullYear()),
      month: String(new Date().getMonth() + 1),
      day: String(new Date().getDate()),
    },
    signature: "成田隆輝",
  };

  public errors = {};
  public errorStyle = {
    display: "flex",
    maxWidth: "100%",
    margin: "0 0 10px 0",
  };

  public connection: WebSocket;
  public connectionId = null;

  public isShowLoadingCertificate = false;

  private id;

  @Watch("isShow")
  public reset() {
    if (this.isShow === false) {
      this.config = {
        is_display_code: true,
        date: {
          year: String(new Date().getFullYear()),
          month: String(new Date().getMonth() + 1),
          day: String(new Date().getDate()),
        },
        signature: "成田隆輝",
      };
    }
    this.clearError("common");
    this.clearError("config.signature");
  }

  @Watch("config.date.month")
  public validateMonth() {
    if (Number(this.config.date.month) > 12) {
      this.config.date.month = "12";
    }
  }

  @Watch("config.date.day")
  public validateDay() {
    if (Number(this.config.date.day) > 31) {
      this.config.date.day = "31";
    }
  }

  public created() {
    this.id = Number(this.$router.currentRoute.params.id);
    if (this.isEdit) {
      this.connectSocket(this.id);
    }
  }

  public beforeDestroy() {
    this.connection?.close();
    this.connection = null;
  }

  public mounted(): void {}

  public async checkForm() {
    this.errors = {};

    if (this.config.date.year === "") {
      this.errors = {
        ...this.errors,
        ...{
          "config.date.year": ["必須入力"],
        },
      };
    }

    if (this.config.date.month === "") {
      this.errors = {
        ...this.errors,
        ...{
          "config.date.month": ["必須入力"],
        },
      };
    }

    if (this.config.date.day === "") {
      this.errors = {
        ...this.errors,
        ...{
          "config.date.day": ["必須入力"],
        },
      };
    }

    if (this.config.signature.length > 5) {
      this.errors = {
        ...this.errors,
        ...{
          "config.signature": ["全角5文字まで"],
        },
      };
    }
  }

  public generateCert() {
    this.isShowLoadingCertificate = true;
    this.clearError("common");
    if (this.disabled) { return; }

    this.checkForm().then(async () => {
      if (isEmpty(this.errors)) {
        try {
          const { is_display_code, date, signature } = this.config;
          const publishDate = moment({
            year: Number(date.year),
            month: Number(date.month) - 1,
            day: Number(date.day),
          }).format("YYYY-MM-DD");

          const data = {
            id: Number(this.$router.currentRoute.params.id),
            isDisplayCode: is_display_code,
            publishDate,
            signName: signature,
          };

          const {
            data: { zipFile },
          } = await LiveManagementLiveService.adminLiveGenerateZipCert(data);

          this.zipFile = zipFile;
          this.isShowLoadingCertificate = false;
          this.isShow = false;
        } catch (error) {
          const result = error.body;
          this.errors = result.errors;
          if (Object.keys(this.errors).length === 0) {
            this.errors = {
              ...this.errors,
              ...{ common: result.message },
            };
          } else if (result.errors.signName) {
            this.errors = {
              ...this.errors,
              ...{ "config.signature": result.message },
            };
          }
          this.isShowLoadingCertificate = false;
        }
      }
    });
  }

  public async exportZipFile() {
    if (!this.zipFile) { return; }

    const {
      data: { url },
    } = await LiveManagementLiveService.adminLiveExportZip({
      id: this.zipFile.id,
    });
    window.open(url, "_blank", "noreferrer");
  }

  public clearError(name) {
    this.errors = { ...this.errors, ...{ [name]: [] } };
  }

  public async connectSocket(liveId) {
    const result = await LiveManagementLiveService.adminLiveConnectSocketUrl({
      livecarp_id: liveId,
    });
    this.connection = new WebSocket(result.data.connect_socket_url);
    this.connection.addEventListener("message", (event: MessageEvent) => {
      const data = JSON.parse(event.data);
      if (data.action === "subcribe") {
        this.connectionId = data.connectionId;
      } else if (
        data.action === "publish" &&
        this.connectionId !== data.connectionId &&
        data.event === "Refresh"
      ) {
      }
    });
    this.connection.addEventListener("open", () => {
      const body: any = {
        action: "subscribe",
        topic: "change-livecarp-status/" + liveId,
      };

      this.connection.send(JSON.stringify(body));
    });
  }
}
